import { useQuery, QueryClient } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys.js";

//** Axios request */
import { request } from "../../utilities/axios-utils.js";

//----------------------------------------------------------------

const getPaymentToken = async (requestData) => {
  try {
    const { jwtToken, priorRequestId } = { ...requestData };

    const isDev = false;

    const tempAccessToken =
      "eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJodHRwczovL2Rldi5lbGlmZWluc3VyZS5jb20uYXUvb2F1dGgyL3Rva2VuIiwiaXNzIjoidGVybWxpZmUtYXBpLmRldiIsInN1YiI6InRlcm1saWZlLWFwaS5kZXYuand0IiwiaWF0IjoxNzA0OTcwNzQxLCJleHAiOjE3MDQ5OTk1NDEsImp0aSI6IjkzY2JkYzg5LTQzODktNDM4MC04Yjg4LTVmMTAwZGQwZTIyMiIsInFpZCI6IjYzNFFBMzQ1NzNBTFAiLCJlbHRpZCI6ImVmOGEzNzQyLTk3MjUtNGY1MC1iYTU4LWNkMDc2Y2Q3Nzk5OSIsIm9rdGFVc2VySWQiOiIwMHUzanN3Z3I2cjZVdlpKYzNsNyIsImNjX3VzZXIiOnRydWUsInVzZXJuYW1lIjoiamNxYiIsImZpcnN0TmFtZSI6IkNvbGluIiwibGFzdE5hbWUiOiJCeXJuZSJ9.Lrnq-Vmg1Aaau0EefOZRMamy2A6aSx1ADb1CHzekTAY";

    const jwtAccessToken = isDev === true ? tempAccessToken : jwtToken;

    const setURL = priorRequestId
      ? `/paymentToken?priorRequestId=${priorRequestId}`
      : `/paymentToken`;

    const response = await request({
      url: setURL,
      method: "GET",
      accessToken: jwtAccessToken,
    });

    const returnResponse = response?.data;

    return returnResponse;
  } catch (ex) {
    console.error(ex);
  }
};

//** Even though both Online and CC call the /paymentToken api,
//** the response is very different for both based on the accessToken passed in.
//** In order to clearly describe their intent and to simplify the mapping and testing of the API,
//** I made a decision to create two separate hooks for both the Online and CC versions of the call.   */

export const useGetSecureCoPaymentToken = (requestData) =>
  useQuery({
    queryKey: [queryKeys.GET_SECURECO_PAYMENT_TOKEN],
    queryFn: async () => await getPaymentToken(requestData),
    refetchOnWindowFocus: false,
    enabled: !!requestData?.jwtToken && requestData?.enabled,
  });
